import { Observable, of as observableOf } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { isTokenExpired } from '../jwt/is-token-expired';
import { OAuthTokenResponse, OAuthTokenRequest } from '../models/auth';
import { tokenStorage, authService } from '../shop/shop-context';

export class TokenHandler {
	/**
	 * This method gets the token from the storage
	 * check if it is still valid if it so it will be returned
	 * otherwise the database will be called to create a new token
	 * with the refresh_token
	 */
	get(): Observable<OAuthTokenResponse> {
		return tokenStorage.get().pipe(
			mergeMap(token => {
				if (token && isTokenExpired(token)) {
					const request: OAuthTokenRequest = {
						grant_type: 'refresh_token',
						refresh_token: token.refresh_token
					};

					// TODO: Should we call authenticate? so we also set the member?
					return authService.token(request);
				}

				return observableOf(token);
			})
		);
	}
}
